//点击菜单跳转到指定位置
var name;
var menuChange = function(menuType){
	if(name != menuType){
		name = menuType
	}else{
		return
	}
	//scrollTop:指定相关模块回到指定位置（该位置要去掉菜单导航栏高度）。
	if(document.getElementsByClassName(menuType) && document.getElementsByClassName(menuType)[0]){
		sliding(document.getElementsByClassName(menuType)[0].offsetTop - 70) //-70是了不要太靠上面，因为导航栏会遮住
	}
}
		
// 页面滑动封装 II 兼容各浏览器、优化数学函数
function sliding(height = 960, time = 500, step = 20) {
	// 优化height过大，代码执行需要额外的时间，导致总时长不一致
	step += Math.ceil(height / 500)
	const speed = Math.floor(time / (height / step))
	let currentPosition = document.documentElement.scrollTop || document.body.scrollTop
	window.sliding2 = setInterval(() => {
		if (Math.abs(currentPosition - height) > step) {
			currentPosition += currentPosition < height ? step : -step
			window.scrollTo(0, currentPosition)
		} else {
		   clearInterval(window.sliding2)
		}
	}, speed)
}
		
export { menuChange }